import * as Sentry from "@sentry/react"

// custom wrapper for errors sent to sentry to include a context of the business logic that caused the error
export const captureExceptionWithContext = (error: any, context: string, userId?: string) => {
  Sentry.withScope((scope) => {
    if (userId) {
      scope.setUser({ id: userId })
    }
    scope.setExtra("context", context)

    if (error instanceof Error) {
      Sentry.captureException(error)
    } else {
      Sentry.captureMessage(typeof error === "object" ? JSON.stringify(error) : error)
    }
  })
}
